import React from "react";
import { Modal, ModalBody } from "reactstrap";
import "./ModalMessages.css";

export default class ModalMessage extends React.Component {
    closemodal = (response) => {
        this.props.cerrarBorrar(response);
    };

    render() {
        const { show, titulo, mensaje, bandera } = this.props;

        return (
            <Modal
                isOpen={!!show}
                size="sm"
                centered
                toggle={() => this.closemodal(0)}
                className="modal-messages"
            >
                <ModalBody className="bodybackgroundblack">
                    <div className="modalmessage-header" style={{ textAlign: "center", color: "black" }}>
                        <p><b>{titulo}</b></p>
                    </div>

                    <br />

                    {bandera === "cambiarContrasena" ? (
                        <div className="modalmessage-body">
                            <p>
                                Se enviaran las instrucciones para recuperar la contraseña ha:
                                <b style={{ color: "black" }}>{" " + mensaje}</b>
                            </p>
                        </div>
                    ) : bandera === "deshabilitar" ? (
                        <div className="modalmessage-body">
                            <p>
                                El producto: <b style={{ color: "black" }}>{" " + mensaje + " "}</b>
                                se deshabilitará. ¿Desea continuar?
                            </p>
                        </div>
                    ) : bandera === "activar" ? (
                        <div className="modalmessage-body">
                            <p>
                                El producto: <b style={{ color: "black" }}>{" " + mensaje + " "}</b>
                                se activará. ¿Desea continuar?
                            </p>
                        </div>
                    ) : bandera === "deshabilitar" ? (
                        <div className="modalmessage-body">
                            <p>
                                El producto: <b style={{ color: "black" }}>{" " + mensaje + " "}</b>
                                se deshabilitará. ¿Desea continuar?
                            </p>
                        </div>
                    ) : bandera === "deshabilitarLocacion" ? (
                        <div className="modalmessage-body">
                            <p>
                                La locación: <b style={{ color: "black" }}>{" " + mensaje + " "}</b>
                                se <b>deshabilitará</b>. ¿Desea continuar?
                            </p>
                        </div>
                    ) : bandera === "activarLocacion" ? (
                        <div className="modalmessage-body">
                            <p>
                                La locación: <b style={{ color: "black" }}>{" " + mensaje + " "}</b>
                                se <b>habilitará</b>. ¿Desea continuar?
                            </p>
                        </div>
                    ) : (bandera === "desvincular") ? (

                        <div className="modalmessage-body">
                            <p>
                                Deseas <b style={{ color: "black" }}>desvincular</b> <b style={{ color: "black" }}>{mensaje}</b>?
                            </p>
                        </div>
                    
                ) : bandera === "cancelarFactura" ? (
                    <div className="modalmessage-body">
                        <p>
                            La factura con Ticket # 
                            <b style={{ color: "black" }}>{" " + mensaje + " "}</b>
                            se <b style={{ color: "black" }}>cancelará</b>. ¿Desea continuar333?
                        </p>
                    </div>
                    ) : (
                        <div className="modalmessage-body">
                            <p>
                                Deseas eliminar <b style={{ color: "black" }}>{mensaje}</b>
                            </p>
                        </div>
                    )}

                    <br />

                    <div className="modalmessage-footer">
                        <button className="buttonshadow message-alert-cancel" onClick={() => this.closemodal(0)}>
                            Cancelar
                        </button>

                        <button className="buttonbase message-alert-ok" onClick={() => this.closemodal(1)}>
                            Continuar
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
